import GenerateEnum from '../generateEnum'
import { getLabelText } from '../utils.js'

/*tradeType	交易类型
1 :支付保证金
2 :划扣保证金
3 :返还保证金*/
export const tradeTypeEnum = GenerateEnum({
  PAY_DEPOSIT: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.payDeposit',
      text: '支付保证金+'
    })
  },
  DEDUCT_DEPOSIT: {
    value: 2,
    label: getLabelText({
      key: 'remote.common.deductDeposit',
      text: '划扣保证金-'
    })
  },
  RETURN_DEPOSIT: {
    value: 3,
    label: getLabelText({
      key: 'remote.common.returnDeposit',
      text: '返还保证金-'
    })
  }
})

/*tradeStatus	 交易状态（0处理中1已完成 2失败3已取消）*/
export const tradeStatusEnum = GenerateEnum({
  PROCESSING: {
    value: 0,
    label: getLabelText({
      key: 'remote.common.processing',
      text: '处理中'
    })
  },
  COMPLETE: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.completed',
      text: '已完成'
    })
  },
  FAIL: {
    value: 2,
    label: getLabelText({
      key: 'remote.common.failure',
      text: '失败'
    })
  },
  CANCEL: {
    value: 3,
    label: getLabelText({
      key: 'remote.common.cancelled',
      text: '已取消'
    })
  }
})

/**
 * 余额提现：就是充值余额和赠送余额提现
 *BALANCE(0, "余额提现"),
 * 佣金提现：就是分销商佣金提现
 *COMMISSION(1, "佣金提现"),
 * 保证金提现：就是保证金账户的提现
 *COMPLIANCE(2, "保证金提现"),
 */
export const withdrawSourceEnum = GenerateEnum({
  BALANCE: {
    value: 0,
    label: getLabelText({
      key: 'remote.common.withdrawalOfBalance',
      text: '余额提现'
    })
  },
  COMMISSION: {
    value: 1,
    label: getLabelText({
      key: 'remote.admin.commissionWithdrawal',
      text: '佣金提现'
    })
  },
  COMPLIANCE: {
    value: 2,
    label: getLabelText({
      key: 'remote.common.bondWithdrawal',
      text: '保证金提现'
    })
  }
})

//withdrawStatus 操作状态（1完成划扣，6取消划扣）
export const withdrawStatusEnum = GenerateEnum({
  COMPLETE: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.withdrawComplete',
      text: '完成划扣'
    })
  },
  CANCEL: {
    value: 6,
    label: getLabelText({
      key: 'remote.common.withdrawCancel',
      text: '取消划扣'
    })
  }
})

/**
 * withdrawStatusEnum
 * 返还状态（0、1返还中，2、4、5返还失败，3返还成功，6取消返还）
 */
export const returnBondStatusEnum = GenerateEnum({
  RETURNING: {
    value: 0,
    label: getLabelText({
      key: 'remote.common.returnBondPending',
      text: '返还中'
    })
  },
  RETURNING_1: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.returnBondPending',
      text: '返还中'
    })
  },
  RETURN_FAIL: {
    value: 2,
    label: getLabelText({
      key: 'remote.common.returnBondFailed',
      text: '返还失败'
    })
  },
  RETURN_FAIL_4: {
    value: 4,
    label: getLabelText({
      key: 'remote.common.returnBondFailed',
      text: '返还失败'
    })
  },
  RETURN_FAIL_5: {
    value: 5,
    label: getLabelText({
      key: 'remote.common.returnBondFailed',
      text: '返还失败'
    })
  },
  RETURN_SUCCESS: {
    value: 3,
    label: getLabelText({
      key: 'remote.common.returnBondSuccess',
      text: '返还成功'
    })
  },
  CANCEL_RETURN: {
    value: 6,
    label: getLabelText({
      key: 'remote.common.returnBondCancel',
      text: '取消返还'
    })
  }
})

/**
 * returnBondWithdrawStatusEnum  审核状态(1审核成功，2审核失败，6取消审核)
 */
export const returnBondWithdrawStatusEnum = GenerateEnum({
  SUCCESS: {
    value: 1,
    label: getLabelText({
      key: 'remote.admin.successfulAudit',
      text: '审核成功'
    })
  },
  FAIL: {
    value: 2,
    label: getLabelText({
      key: 'remote.admin.auditFailed',
      text: '审核失败'
    })
  },
  CANCEL: {
    value: 6,
    label: getLabelText({
      key: '',
      text: '取消审核'
    })
  }
})



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/enum/bond.js